import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-state-column',
  templateUrl: './state-column.component.html',
  styleUrl: './state-column.component.scss'
})
export class StateColumnComponent {
  @Input() value: string | boolean | undefined;

}
